import constants from './constants';

const initialState = {
  error: null,
  pending: false
}

const createCalendar = (state = initialState, action) => {
  switch (action.type) {
    case `${constants.CREATE_CALENDAR}_STARTED`:
      return {...state, pending: true}
    case `${constants.CREATE_CALENDAR}_ENDED`: {
      const {newEvent, sentAt} = action.data.data;
      return {...state, pending: false, ...newEvent, sentAt}
    }
    case constants.RESET_DATA:
      return initialState;
    default:
      return state;
  }
}

export default createCalendar